import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type SliceMediaState = {
  selectedParentIdHierarchy: string[];
  viewType: "grid" | "tile";
};

const initialState: SliceMediaState = {
  selectedParentIdHierarchy: [],
  viewType: "tile",
};

const slice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setSelectedParentIdHierarchy: (draft, action: PayloadAction<string[]>) => {
      draft.selectedParentIdHierarchy = action.payload;
    },
    setMediaViewType: (
      draft,
      action: PayloadAction<SliceMediaState["viewType"]>,
    ) => {
      draft.viewType = action.payload;
    },
  },
});

export const { setSelectedParentIdHierarchy, setMediaViewType } = slice.actions;

export const reducerMedia = slice.reducer;
